import { render, staticRenderFns } from "./ManterUsuario.vue?vue&type=template&id=6fff63a9&scoped=true&"
import script from "./ManterUsuario.vue?vue&type=script&lang=js&"
export * from "./ManterUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fff63a9",
  null
  
)

export default component.exports